import { IComponentOptions, IController } from 'angular';
import './select-group-registration.component.scss';
import { $Event } from '../../../../helpers';

export class SelectRoleController implements IController {
    static $inject = [
        'StorageService',
    ];
    groupSelected: ($event) => void;
    selectedGroup: string;
    constructor() {
    }

    $onInit() {
    }

    groupSelect($event) {
        this.groupSelected(new $Event($event));
    }
}


export const SelectGroupRegistrationComponent: IComponentOptions = {
    controller: SelectRoleController,
    template: require('./select-group-registration.component.html'),
    bindings: {
        groupSelected: '&'
    }
};



// WEBPACK FOOTER //
// ./app/states_mobile/auth/components/select-group-registration/select-group-registration.component.ts